<div class="container">
  <div class="row center">
    <div class="col col-50 white">
      <app-spinner
        [display]="true"
        [class]="'spinner-container'"
        [messageToDisplay]="'Session created'"
      ></app-spinner>
    </div>
  </div>
</div>
